import i18next, { TFunction } from 'i18next'
import { VariantClassesProps } from '../index'

export const MIN_PASSWORD_LENGTH = 8

export const emailProviders = {
    gmail: 'https://mail.google.com/mail/u/0/#inbox',
    yahoo: 'https://outlook.live.com/mail/inbox',
    outlook: 'https://outlook.live.com/mail/inbox',
}

export const typeMaps: VariantClassesProps = new Proxy(
    {} as VariantClassesProps,
    {
        get: (_target, key: string) => {
            const map: Record<string, string> = {
                'profile-status-change': i18next.t(
                    'user:history-types.profile-status-change'
                ),
                'user-data-update': i18next.t(
                    'user:history-types.user-data-update'
                ),
                'aai-edu-authorization': i18next.t(
                    'user:history-types.aai-edu-authorization'
                ),
                'student-status-change': i18next.t(
                    'user:history-types.student-status-change'
                ),
            }
            return map[key]
        },
    }
)

export const statusOptions = (t: TFunction) => [
    { id: 0, label: t('utils:status.active'), value: 'active' },
    { id: 1, label: t('utils:status.inactive'), value: 'inactive' },
    { id: 2, label: t('utils:status.archived'), value: 'archived' },
]

export const defaultNotification: NotificationType = {
    msg: '',
    type: 'success',
}
